import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface RouterState {
  activeRoute: string | null;
}

const initialState: RouterState = {
  activeRoute: null
};

export const RouterSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {
    performNavigation: (state, action: PayloadAction<string>) => {
      state.activeRoute = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const { performNavigation } = RouterSlice.actions;

export default RouterSlice.reducer;
